import { useEffect, type FC } from 'react'
import { usePlaidLink } from 'react-plaid-link'
import { Logger } from '@egw/logger'
import { sendEvent } from '@egw/events'
import { type PlaidSDKWrapperProps } from '../../../types/plaid-multi-link'

const log = new Logger('Plaid SDK Wrapper')

export const PlaidSDKWrapper: FC<PlaidSDKWrapperProps> = ({ children, token, onSuccess, onError, onExit }) => {
  const { open, ready, error } = usePlaidLink({
    token,
    onSuccess: (publicToken, metadata) => {
      log.info('Plaid onSuccess with metadata', { publicToken, metadata })
      sendEvent('eg_plaidMultiLink_plaidOnSuccess', {
        eventSource: 'egWealth',
        category: 'plaid-multi-link',
        subCategory: 'plaid-sdk',
        plaidMetaData: metadata,
      })
      onSuccess(metadata)
    },
    onExit: (plaidError, metadata) => {
      log.info('Plaid onExit with metadata', { plaidError, metadata })
      sendEvent('eg_plaidMultiLink_plaidOnExit', {
        eventSource: 'egWealth',
        category: 'plaid-multi-link',
        subCategory: 'plaid-sdk',
        plaidMetaData: metadata,
        plaidError,
      })
      onExit()
    },
    onEvent: (eventName, metadata) => {
      log.info('Plaid onEvent', { eventName, metadata })
      sendEvent('eg_plaidMultiLink_plaidOnEvent', {
        eventSource: 'egWealth',
        category: 'plaid-multi-link',
        subCategory: 'plaid-sdk',
        plaidEventName: eventName,
        plaidMetaData: metadata,
      })
    },
  })

  useEffect(() => {
    if (ready) {
      sendEvent('eg_plaidMultiLink_plaidOpen', {
        eventSource: 'egWealth',
        category: 'plaid-multi-link',
        subCategory: 'plaid-sdk',
      })
      open()
    }
  }, [ready, open])

  useEffect(() => {
    if (error) {
      onError()
    }
  }, [error, onError])

  return <>{children}</>
}
